import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE = 'https://dodoskills.com.au';

// Keeps <link rel="canonical"> (set to the homepage in index.html) pointing
// at the page being viewed, so a search engine does not treat every public
// page as a copy of the homepage. Always the real site address, whatever
// address the page was opened on, and never with a query string.
export function CanonicalLink() {
  const { pathname } = useLocation();
  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    );
    if (!link) return;
    link.href = SITE + (pathname === '/' ? '/' : pathname.replace(/\/+$/, ''));
  }, [pathname]);
  return null;
}
